module.exports = __webpack_public_path__ + "img/img-fachai-d.f9b6a304.png";